import { KeyboardArrowDown } from '@mui/icons-material';
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
} from '@mui/material';
import { useStudioAuthenticatedContext } from '../../context/StudioContext';
import { formatAppSetDisplayName } from '../../util/appSetUtils';
import styles from './AppSetSelector.module.css';

export const AppSetSelector = () => {
  const { appSets, selectedAppSet, setSelectedAppSet } = useStudioAuthenticatedContext();

  const handleAppSetChange = (event: SelectChangeEvent<number>) => {
    const selectedId = event.target.value as number;
    const newSelectedAppSet = appSets?.find(appSet => appSet.productionApp.id === selectedId);
    if (newSelectedAppSet) {
      setSelectedAppSet(newSelectedAppSet);
    }
  };

  // Don't render if no app sets available
  if (!appSets || appSets.length === 0) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <FormControl fullWidth size="small" className={styles.formControl}>
        <Select
          value={selectedAppSet?.productionApp.id ?? appSets[0]?.productionApp.id}
          onChange={handleAppSetChange}
          displayEmpty
          IconComponent={KeyboardArrowDown}
          className={styles.select}
          MenuProps={{
            PaperProps: {
              className: styles.menuPaper,
            },
          }}
        >
          {appSets.map((appSet) => (
            <MenuItem
              key={appSet.productionApp.id}
              value={appSet.productionApp.id}
              className={styles.menuItem}
            >
              {formatAppSetDisplayName(appSet)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}; 